module.exports = __webpack_public_path__ + "img/index_pic11.fe18acf9.png";